<ul class="dvb-report-download list-inline">
    <li>
        <dvb-loading-button type="submit" is-loading="vm.loadingReport" on-click="vm.download()">
            <span data-translate="COMMON.REPORT_GENERIEREN"></span>
        </dvb-loading-button>
    </li>
</ul>
